import { render, staticRenderFns } from "./Suggested.vue?vue&type=template&id=943e55d4&scoped=true&"
import script from "./Suggested.vue?vue&type=script&lang=js&"
export * from "./Suggested.vue?vue&type=script&lang=js&"
import style0 from "./Suggested.vue?vue&type=style&index=0&id=943e55d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943e55d4",
  null
  
)

export default component.exports